import { createFileRoute, redirect } from '@tanstack/react-router';

import { HomePage } from '@/pages/home';

export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    const hasSession = await context.auth.userRefetch().catch(() => null);

    if (hasSession) {
      throw redirect({ to: '/courses' });
    }
  },
  component: HomePage,
});
